import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  InputGroup,
  Input,
  InputGroupText,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  Spinner,
} from "reactstrap";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import { CheckBudgetYear } from "../../../Function/CheckBudgetYear";
import { ConvertDate } from "../../../Function/ConvertDate";
import { ChunkArray } from "../../../Function/ChunkArray";
import SelectOrg from "../../selectOrg/selectOrg";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingData from "../../../TESTPage/LoadingData";
import SubMenuEntryWork from "../../SubMenuEntryWork";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import { FetchAxiosGet } from "../../../../api/axios";
import { CheckPosition } from "../../../Function/CheckPosition";
import { CheckSubAdmin } from "../../../Function/CheckSubAdmin";

const Menu3 = ({ userInfos }) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const user_id = user?.user_id;
  const org_id = userPosition[0]?.org_id
  const month = new Date()?.getMonth();

  const [timeHistoryOrg, setTimeHistoryOrg] = useState([]);
  const [entryHistoryOrg, setEntryHistoryOrg] = useState([]);
  const [outHistoryOrg, setOutHistoryOrg] = useState([]);
  const [divisionOrg, setDivisionOrg] = useState(null);
  const [groupOrg, setGroupOrg] = useState(null);
  const [userOrg, setUserOrg] = useState(null);
  const [loadingDatatable, setLoadingDatatable] = useState(true);
  const [hasFilter, setHasFilter] = useState(false)

  const [chunkEntry, setChunkEntry] = useState([]);
  const [data, setData] = useState([]);
  const [entryPagination, setEntryPagination] = useState({
    page: 0,
    totalRows: 0,
    totalPage: 0,
  });

  // const [startDate ,setStartDate] = useState(new Date().setDate(new Date().getDate() - 30))
  const [startDate ,setStartDate] = useState(new Date())
  const [toDate ,setToDate] = useState(new Date())

  const getEntryHistoryByOrgId = async (id, orgDivision = null, orgGroup = null, orgUser = null) => {
    try {
      setLoadingDatatable(true)
      const url = baseURL + "/api/time/history"
      let params = new URLSearchParams({
        // page: entryPagination.page,
        page: 1,
        size: 10000,
        "order[0]": "scan_date",
        "order[1]": "DESC",
        // "filter[budget_year][0]": CheckBudgetYear(),
        date_start: ConvertDate(startDate).toOnlyDate(),
        date_end: ConvertDate(toDate).toOnlyDate(),
        // "filter[user_scan_id][0]": 902,
        // "filter[entry_exit_status][0]": 0,
        // "filter[entry_exit_status][1]": 1,
      })

      // if (startDate && toDate && hasFilter) {
      //   params.append("date_start", ConvertDate(startDate).toOnlyDate())
      //   params.append("date_end", ConvertDate(toDate).toOnlyDate())
      //   params.delete("filter[budget_year][0]", CheckBudgetYear())
      // }
      if (orgDivision !== null) {
        params.append("filter[cont_to_id][0]", orgDivision)
      }
      if (orgGroup !== null) {
        if (orgGroup?.length > 0 && typeof orgGroup !== "string") {
            orgGroup.forEach((element,idx) => {
              params.append(`filter[cont_to_id][${idx + 1}]`, element)
            });
        } else {
          params.append("filter[cont_to_id][0]", orgGroup)
        }
      }
      if (orgUser !== null) {
        params.append("filter[user_id][0]", orgUser)
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }, params
      }

      const res = await axios.get(url, config)
      setTimeHistoryOrg(res?.data?.result);

      setTimeout(() => {
        setLoadingDatatable(false)
      }, 1500);
    } catch (err) {
      console.error(err);
    }
  };

  const filterOrgNodelv = async (id) => {
    const url = '/api/orgInner/level'
    const res = await FetchAxiosGet(url, token)

    const combinedArray = [
      ...res.result.child?.map(org => org),
      ...res.result.child?.flatMap(org =>
        org.child?.map(i => i)
      ),
    ];
    let filter_active = combinedArray.filter(i => i.active == 1)
    filter_active = filter_active?.find(x => x.org_id == id)

    if (CheckPosition(userPosition).length > 0) {
      if (CheckPosition(userPosition)?.includes(7) || CheckPosition(userPosition)?.includes(6)) {
        getEntryHistoryByOrgId(undefined, null, org_id);
      } else if (CheckPosition(userPosition)?.includes(5)) {
        getEntryHistoryByOrgId(undefined, filter_active?.org_id, filter_active?.child);
      }
    } else if (CheckSubAdmin(user?.positionSubAdmin).length > 0 && (CheckSubAdmin(user?.positionSubAdmin).includes(0) || CheckSubAdmin(user?.positionSubAdmin).includes(2))) {
      getEntryHistoryByOrgId(undefined, filter_active?.org_id, filter_active?.child);
    }
  }
  
  useEffect(() => {
    filterOrgNodelv(org_id)
    // getEntryHistoryByOrgId(undefined, org_id);
    // fetchInfo()
  }, [])

  // useEffect(() => {
  //   hasFilter ? getEntryHistoryByOrgId(org_id, divisionOrg, groupOrg, userOrg) : getEntryHistoryByOrgId(org_id)
  // }, [entryPagination.page])

  // useEffect(() => {
  //   setLoadingDatatable(true)
  //   getEntryHistoryByOrgId(org_id);
  //   setTimeout(() => {
  //     setLoadingDatatable(false)
  //   }, 1500);
  // }, [entryPagination.page]);

  const setDataToEntryAndOutOrg = () => {
    setEntryHistoryOrg([]);
    setOutHistoryOrg([]);
    if (timeHistoryOrg?.length == 0) {
      setChunkEntry([[]]);
      setEntryPagination({
        page: 0,
        totalRows: 0,
        totalPage: 0,
      })
    }
    timeHistoryOrg?.map((item) => {
      if (item?.entry_exit_status !== 1) {
        setEntryHistoryOrg((prev) => [...prev, item]);
      } else {
        setOutHistoryOrg((prev) => [...prev, item]);
      }
      return null;
    });
  };

  useEffect(() => {
    setDataToEntryAndOutOrg();
  }, [timeHistoryOrg]);

  useEffect(() => {
    if (entryHistoryOrg?.length > 0) {
      setChunkEntry(ChunkArray(entryHistoryOrg, 10));
      if (entryPagination?.page === 0) {
          setEntryPagination((prev) => ({
          ...prev,
          page: 1,
          totalRows: entryHistoryOrg?.length,
          totalPage: ChunkArray(entryHistoryOrg, 10)?.length,
        }));
      }
    }
  }, [entryHistoryOrg]);



  const [searchData, setSearchData] = useState();
  const [searchDataTo, setSearchDataTo] = useState();
  const [checkButton, setCheckButton] = useState(true);

  const handleFilter = async () => {
    setHasFilter(true)
      if (arrayPushOrgGroup !== null && arrayPushOrgGroup?.length > 0) {
        await getEntryHistoryByOrgId(org_id, divisionOrg, arrayPushOrgGroup, userOrg);
      } else {
        await getEntryHistoryByOrgId(org_id, divisionOrg, groupOrg, userOrg);
    }
      setEntryPagination((prev) => ({
        ...prev,
        page: 1,
        totalRows: entryHistoryOrg?.length,
        totalPage: ChunkArray(entryHistoryOrg, 10)?.length,
      }))
  }

  const setSearchDate = (e) => {
    setStartDate(e)
    setToDate(e)
  }

  useEffect(() => {
    setEntryPagination((prev) => ({
      ...prev,
      page: prev.page,
      totalRows: entryHistoryOrg?.length,
      totalPage: chunkEntry?.length,
    }))
  }, [chunkEntry])

  const [arrayOrgGroup, setArrayOrgGroup] = useState(null)
  const [arrayPushOrgGroup, setArrayPushOrgGroup] = useState(null)

  useEffect(() => {
   if (arrayOrgGroup !== null) {
    let arrayPop = []
      arrayOrgGroup?.map(i=>(
        arrayPop.push(i?.org_id)
      ))
      setArrayPushOrgGroup(arrayPop)
   }
  }, [arrayOrgGroup])

  useEffect(() => {
   if (groupOrg !== null) {
    setArrayPushOrgGroup(null)
   }
  }, [groupOrg])

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <React.Fragment>
      <SubMenuEntryWork menu={2} />
      <Breadcrumb
        title="หน้าหลัก"
        breadcrumbItem="ลงเวลาปฏิบัติราชการ"
        isBack={true}
        isSubMenu={true}
        subMenuName="ค้นหาข้อมูลเข้าทำงาน"
        path="/entrywork"
      />
      <Card>
        <CardBody>
          <Row>
            <Col>
              <Form>
                <SelectOrg setDivisionOrg={setDivisionOrg} setGroupOrg={setGroupOrg} setUserOrg={setUserOrg} arrayOrgGroup={setArrayOrgGroup}/>
                <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
                  <Label className="text-end" md={1} xxl={2}>
                    ค้นหาช่วงวันที่
                  </Label>
                  <Col xs={12} md={4} xl={3}>
                    <InputGroup className={` 
                      ${windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) || (windowSize.width >= 992 && windowSize.width < 1200 )
                        ? "d-flex justify-content-end mb-2" 
                        : ""}`}
                      >
                      <InputGroupText>ตั้งแต่วันที่</InputGroupText>
                      <NewThaiDatePicker rounded="rounded-start-0" value={startDate} setValue={setStartDate} 
                      // maxDate={searchDataTo}
                      placeholderText="วัน/เดือน/ปี" showClearButton={true} />
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={4} xl={3}>
                    <InputGroup className={` 
                        ${windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) || (windowSize.width >= 992 && windowSize.width < 1200 )
                          ? "d-flex justify-content-end mb-2" 
                          : ""}`}
                        >
                      <InputGroupText>ถึงวันที่</InputGroupText>
                      <NewThaiDatePicker rounded="rounded-start-0" value={toDate} setValue={setToDate} minDate={startDate} placeholderText="วัน/เดือน/ปี" showClearButton={startDate !== null} />
                    </InputGroup>
                  </Col>

                  <Col xs={12} md={2} xl={2} className="d-flex justify-content-end">
                    <Button
                      className="w-50"
                      color="success"
                      onClick={() => {
                        handleFilter()
                        if (searchData === "" || searchDataTo === "") {
                          setCheckButton(true)
                        }
                      }}
                    // disabled={checkButton}
                    >
                      <i className="fas fa-search me-2"></i>
                      ค้นหา
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col xxl={12}>
              {/* {!isloading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "350px",
                      }}
                    >
                      <LoadingData />
                    </div>
                  ) : (
                    
                  )} */}
              <FadeIn>
                <div>
                  <Table striped hover style={{ verticalAlign: "middle" }} responsive>
                    <thead className="table-dark">
                        <tr>
                          <th className="text-center">ลำดับ</th>
                          <th>ชื่อ</th>
                          <th className="text-center">วันที่</th>
                          <th className="text-center">
                            เวลาเข้า-เวลาออก
                          </th>
                          <th className="text-center">สถานะ</th>
                          <th className="text-center">
                            ชั่วโมงการทำงานล่วงเวลา
                          </th>
                        </tr>
                      </thead>
                    <tbody>
                      {
                      loadingDatatable ?
                        <tr>
                          <td colSpan={6}>
                            <LoadingData />
                          </td>
                        </tr>

                        : 
                        chunkEntry[entryPagination?.page - 1]?.length > 0 ?
                          chunkEntry[entryPagination?.page - 1]?.map((item, idx) => {
                            const ScanDate = item?.scan_date?.split("T");
                            const dateEntry = ScanDate[0];
                            const time = ScanDate[1]?.split(".");
                            const timeEntry = time[0];

                            const match = outHistoryOrg?.filter((item2) => item?.scan_date?.split("T")[0] === item2?.scan_date?.split("T")[0] && item?.user_id === item2?.user_id);
                            let scanDate = match[0]?.scan_date
                              ?.split("T")[1]
                              ?.split(".")[0];

                              let OvertimeHours =
                                match[0]?.overtime && match[0]?.entry_exit_status === "1" ?
                                  parseInt(match[0]?.working_hours?.split( ":")[0]) - 8
                                    : match[0]?.overtime && match[0]?.entry_exit_status !== "1" ?
                                      match[0]?.working_hours?.split(":")[0] : 0;

                              let OvertimeMinutes = match[0]
                                ?.overtime
                                ? match[0]?.working_hours?.split(
                                    ":"
                                  )[1]
                                : 0;
                                
                            return (
                              <tr key={idx}>
                                <td className="text-center">{((entryPagination?.page - 1) * 10) + (idx + 1)}</td>
                                <td>{item?.user_name}</td>
                                <td className="text-center">{ConvertDate(dateEntry).toThaiDateFullDMY()}</td>
                                <td className="text-center">
                                  {item?.entry_exit_status === 0  || item?.entry_exit_status === 5
                                    ? `${timeEntry}`
                                    : '-'}
                                  {match[0]?.scan_date ===
                                  undefined
                                    ? null
                                    : " - "}
                                  {match[0]?.scan_date !==
                                  undefined
                                    ? `${scanDate}`
                                    : null}
                                </td>
                                <td className="text-center">{item?.entry_exit_status === 4 || item?.entry_exit_status === 3 ? item?.entry_exit_status_name : item?.note}</td>
                                {OvertimeHours === 0 && OvertimeMinutes === 0 ? <td className="text-center">-</td> : <td className="text-center">
                                  {OvertimeHours} ชั่วโมง{" "}
                                  {OvertimeMinutes} นาที
                                </td>}
                              </tr>
                            );
                          })
                          : <tr><td colSpan={6} className="text-center" style={{ fontSize: "16px" }}>ไม่มีข้อมูล</td></tr>
                      }


                    </tbody>
                  </Table>
                </div>
              </FadeIn>
            </Col>
          </Row>
        </CardBody>
        {/* {entryHistoryOrg?.length > 0 && ( */}
          <Row
            className="mx-2"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <Col xxl={4} sm={3} xs={12} className="mb-2">
              <h4>
                <Badge className="badge-soft-primary me-1">
                  ทั้งหมด {entryPagination?.totalRows} รายการ
                </Badge>
              </h4>
            </Col>
            <Col xxl={8} sm={9} xs={12} className="d-flex justify-content-end">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={entryPagination?.page === 1}>
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({ ...prev, page: 1 }))
                    }
                  >
                    หน้าแรก
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={entryPagination?.page === 1}>
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.page - 1,
                      }))
                    }
                  >
                    ย้อนกลับ
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem active>
                  <PaginationLink>
                    {/* {spiner ? <Spinner color="light"/> : `หน้า ${entryPagination?.page} จาก ${entryPagination?.totalPage} `} */}
                    หน้า {entryPagination?.page} จาก {entryPagination?.totalPage} 
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    entryPagination?.page === entryPagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.page + 1,
                      }))
                    }
                  >
                    ถัดไป
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    entryPagination?.page === entryPagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.totalPage,
                      }))
                    }
                  >
                    หน้าสุดท้าย
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        {/* )} */}
      </Card>
    </React.Fragment>
  );
}

export default Menu3;
